/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { StyleSheet } from "react-native";
import Button from "react-bootstrap/Button";

interface ButtonVProps {
  buttonText: string;
  buttonStyle?: object;
  [key: string]: any;
}

export const ButtonV = (props: ButtonVProps) => {
  const { buttonText, buttonStyle } = props;
  return (
    <Button {...props} style={StyleSheet.flatten([buttonStyle])}>
      {buttonText}
    </Button>
  );
};
